<template>
  <CoverLayout v-if="isShow">
    <div class="contactUsLayout" slot="content">
      <div class="icon_close" @click="handleClose"></div>
      <div class="title">联系我们</div>
      <div class="subTitle">
        感谢您的关注，请留下您的联系方式，我们会主动联系您：
      </div>
      <div class="choseType">选择联系事宜：</div>
      <el-form ref="dataForm" :model="form" label-position="top" :rules="rules">
        <el-form-item prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="0">商务合作</el-radio>
            <el-radio :label="1">媒体采访</el-radio>
            <el-radio :label="2">投诉与建议</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="您的姓名：" prop="name">
          <el-input placeholder="请输入您的姓名" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="contactInformation">
          <el-input
            placeholder="请输入您的联系电话"
            v-model="form.contactInformation"
          ></el-input>
        </el-form-item>
        <el-form-item label="您的需求：" prop="content">
          <el-input
            placeholder="请输入您的需求"
            v-model="form.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="otherWay">
        或者您可通过邮箱联系我们：<span>service@chrivc.cn</span>
      </div>
      <div class="text_center">
        <Btn btnText="提交" @handleClick="submit" :width="162" />
      </div>
    </div>
  </CoverLayout>
</template>

<script>
import Btn from "./Btn.vue";
import CoverLayout from "./CoverLayout.vue";
import { feedbackSave } from "@/api/feedback";
export default {
  components: { CoverLayout, Btn },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        type: 0
      },
      rules: {
        // type: [
        //   { required: true, message: "请选择联系事宜", trigger: "change" }
        // ],
        contactInformation: [
          { required: true, message: "联系电话不能为空", trigger: "blur" }
        ],
        content: [
          { required: true, message: "您的需求不能为空", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleClose() {
      console.log("handleClose");
      this.form = {
        type: 0
      };
      this.$emit("handleClose");
    },
    submit() {
      //   console.log(this.form);
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          feedbackSave(this.form).then(res => {
            if (res.data.c === 200) {
              this.$message.success("提交成功");
              this.form = {
                type: 0
              };
              this.$emit("handleClose");
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.text_center {
  text-align: center;
  margin-top: 32px;
}
.contactUsLayout {
  width: 751px;
  height: 618px;
  background-color: #fff;
  background: url("../assets/ctu_bg.png") no-repeat;
  background-size: cover;
  padding: 30px 160px 43px 160px;

  border-radius: 16px;
  position: relative;
  box-sizing: border-box;
  .icon_close {
    background: url("../assets/icon_ctu_close.png");
    background-size: cover;
    width: 14px;
    height: 14px;
    display: inline-block;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }

  //   .topBg {
  //     background: url("../assets/contactUs_bg.png") no-repeat;
  //     height: 160px;
  //     position: absolute;
  //     left: 0;
  //     width: 100%;
  //     background-size: cover;
  //     top: 0;
  //     .topBgCorner {
  //       background: url("../assets/topBgCorner.png") no-repeat;
  //       background-size: cover;
  //       width: 92px;
  //       height: 33px;
  //     }
  //   }
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3a61b1;
    text-align: center;
    margin-bottom: 30px;
  }
  .subTitle {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #393939;
    margin-bottom: 25px;
  }
  .choseType {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    margin-bottom: 20px;
  }
  >>> .el-form-item {
    margin-bottom: 10px;
  }
  >>> .el-input {
    // border-radius: 4px;
    .el-input__inner {
      border: 1px solid #d7d7d7;
      height: 37px;
    }
  }
  >>> .el-form-item__label {
    // font-size: 14px;
    font-family: PingFang SC;
    // font-weight: 400;
    color: #6e6e6e;
    height: 40px;
  }
  .el-radio-group {
    display: flex;
    justify-content: space-between;
    >>> .el-radio__label {
      color: #393939;
    }
  }
  .otherWay {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    margin-top: 30px;
    span {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #393939;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DialogContactUs.vue